const side = [
    {
        name: '个人首页',
        path: 'personalHomepage',
        index: '1',
        icon: '',
        decide: [
            'my-info',
        ],
    },
    {
        name: '知识库',
        path: '',
        index: '2',
        icon: 'iconfont icon-knowledge-full',
        decide: [
            'bank-article',
            'bank-questionnaire',
            'bank-greetings',
            'bank-remind',
            'push',
            'bank-uploadVideo',
        ],
        children: [
            {
                name: '图文知识',
                path: 'courseView',
                index: '2-1',
                icon: '',
                decide: ['bank-article'],
            },
            {
                name: '视频科普',
                path: 'uploadVideo',
                index: '2-6',
                icon: '',
                decide: ['bank-uploadVideo'],
            },
            {
                name: '问卷管理',
                path: 'questionnaireView',
                index: '2-2',
                icon: '',
                decide: ['bank-questionnaire'],
            },
            {
                name: '问候语',
                path: 'greetingsView',
                index: '2-3',
                icon: '',
                decide: ['bank-greetings'],
            },
            {
                name: '通用提醒',
                path: 'comRemindView',
                index: '2-4',
                icon: '',
                decide: ['bank-remind'],
            },

            {
                name: '内容推送',
                path: 'pushRoleView',
                index: '2-5',
                icon: '',
                decide: ['push-life'],
                tab_list: [
                    {
                        name: '生命周期',
                        path: 'SDLCView',
                        index: '3-3-1',
                        decide: ['push-life-all'],
                    },
                ]
            },
        ]
    },
    {
        name: '业务运营',
        path: '',
        index: '3',
        icon: 'iconfont icon-yunyingzhongxin',
        decide: [
            'staff-staff',
            'hos-hos',
            'doctor-doctor',
            'sick-audit',
            'bill-audit',
            'visit-audit',
            'patient',
            'schedule',
            'advisory-messages',
            'pharmacist-pharmacist',
            'follow-up-list',
            'hisDataEdit'
        ],
        children: [
            {
                name: '组织架构',
                path: 'staffView',
                index: '3-1',
                icon: '',
                decide: ['staff-staff'],
            },
            {
                name: '医院管理',
                path: 'hospitalView',
                index: '3-2',
                icon: '',
                decide: ['hos-hos'],
            },
            {
                name: '医生管理',
                path: 'doctorView',
                index: '3-3',
                icon: '',
                decide: ['doctor-doctor'],
            },
            {
                name: '药师管理',
                path: 'pharmacist',
                index: '3-11',
                icon: '',
                decide: ['pharmacist-pharmacist'],
            },
            {
                name: '活动管理',
                path: 'activeManageView',
                index: '3-12',
                icon: '',
                decide: ['activeManage-activeManage'],
            },
            {
                name: '注册审核',
                path: 'illAuditView',
                index: '3-4',
                icon: '',
                decide: ['sick-audit'],
            },
            {
                name: '发票审核',
                path: 'billAuditView',
                index: '3-5',
                icon: '',
                decide: ['bill-audit'],
            },
            {
                name: '随访工单',
                path: 'followVisitView',
                index: '3-6',
                icon: '',
                decide: ['visit-audit'],
            },
            {
                name: '随访指定清单',
                path: 'followUpList',
                index: '3-10',
                icon: '',
                decide: ['follow-up-list'],
                tab_list: [
                    {
                        name: '随访指定清单',
                        path: 'followView',
                        index: '3-10-1',
                        decide: ['follow-up-list'],
                    },
                    {
                        name: '随访排除清单',
                        path: 'unfollowView',
                        index: '3-10-2',
                        decide: ['follow-up-unlist'],
                    },
                ]
            },
            {
                name: '留言咨询',
                path: 'advisoryMessages',
                index: '3-9',
                icon: '',
                decide: ['advisory-messages']
            },
            {
                name: '患者数据',
                path: 'patientData',
                index: '3-7',
                icon: '',
                decide: ['patient-data', 'patient-stat']
            },
            {
                name: '填报进度',
                path: 'PAScheduleView',
                index: '3-8',
                icon: '',
                decide: ['schedule-data', 'schedule-stat', 'export-stat'],
                tab_list: [
                    {
                        name: '填报汇总',
                        path: 'exportStatView',
                        index: '3-8-3',
                        decide: ['export-stat'],
                    },
                    {
                        name: '详细数据',
                        path: 'detailView',
                        index: '3-8-1',
                        decide: ['schedule-data'],
                    },
                    {
                        name: '统计',
                        path: 'statisticsView',
                        index: '3-8-2',
                        decide: ['schedule-stat'],
                    },
                ]
            },
            {
                name: '数据申请',
                path: 'hisDataEditView',
                index: '3-10',
                icon: '',
                decide: ['hisDataEdit-hisDataEdit']
            },
            {
                name: '数据修复',
                path: 'dataRecovery',
                index: '3-11',
                icon: '',
                decide: ['dataRecovery-dataRecovery']
            },
        ]
    },
    {
        name: '系统管理',
        path: '',
        index: '4',
        icon: 'iconfont icon-shezhi',
        decide: [
            'sys',
            'ill-ill',
            'operation-operation',
            'dictionaries-dictionaries',
            'integral',
            'drugstore-drugstore',
            'hash-tool'
        ],
        children: [
            {
                name: '运营用户',
                path: 'systemUserView',
                index: '4-1',
                icon: '',
                decide: ['sys-user', 'sys-role'],
                tab_list: [
                    {
                        name: '用户',
                        path: 'userView',
                        index: '4-5-1',
                        decide: ['sys-user'],
                    },
                    {
                        name: '角色',
                        path: 'roleView',
                        index: '4-5-2',
                        decide: ['sys-role'],
                    }
                ]
            },

            {
                name: '病种管理',
                path: 'illView',
                index: '4-2',
                icon: '',
                decide: ['ill-ill'],
            },
            {
                name: '操作日志',
                path: 'ULogView',
                index: '4-3',
                icon: '',
                decide: ['operation-operation'],
            },
            {
                name: '字典管理',
                path: 'dictionariesView',
                index: '4-4',
                icon: '',
                decide: ['dictionaries-dictionaries'],
            },
            {
                name: '直播管理',
                path: 'liveView',
                index: '4-10',
                icon: '',
                decide: ['live-live'],
            },

            {
                name: '积分配置',
                path: 'integralView',
                index: '4-5',
                icon: '',
                decide: ['integral-rule', 'integral-level'],
                tab_list: [
                    {
                        name: '积分规则',
                        path: 'ruleView',
                        index: '4-5-1',
                        decide: ['integral-rule'],
                    },
                    {
                        name: '积分等级',
                        path: 'levelView',
                        index: '4-5-2',
                        decide: ['integral-level'],
                    },
                    {
                        name: '积分设置',
                        path: 'setupView',
                        index: '4-5-3',
                        decide: ['integral-setup'],
                    }
                ]
            },

            {
                name: '药店列表',
                path: 'drugstoreView',
                index: '4-6',
                icon: '',
                decide: ['drugstore-drugstore'],
            },
            {
                name: '产品配置',
                path: 'drugConfigView',
                index: '4-8',
                icon: '',
                decide: ['drugConfig-drugConfig'],
            },
            {
                name: 'hash工具',
                path: 'hashView',
                index: '4-7',
                icon: '',
                decide: ['hash-tool'],
            },
        ]
    },
    // {
    //     name: '系统设置',
    //     path: '',
    //     index: '5',
    //     icon: 'iconfont icon-shezhi',
    //     decide: [],
    //     children: [
    //
    //     ]
    // },

];
export default side